import { SANS_2, SANS_3, getText } from 'oolib';
import * as Typo2 from 'oolib/dist/v2/components/Typo2';
import React from 'react';

import { formatters } from '../utils/formatters';

const TableText = ({
    value: _value, 
    tableRowData, 
    typoComp = 'UI_BODY_SM_DF', // any Typo2 export by name (UI_BODY_SEMIBOLD_SM, UI_CAPTION, ...) or the legacy SANS_2 / SANS_3
    color,
    suffix,
    formatter,
    ...typoCompProps
}) => {
    
    
    // ensures that if value doesnt exist or rich text data has not text, then dont return the comp
    // so the table elem defaults to showing a  '-'
    if(!_value || (_value.blocks && _value.blocks.length === 0) ) return null;

    let comps = { SANS_2, SANS_3 }

    let TYPO_COMP = comps[typoComp] || Typo2[typoComp] || Typo2.UI_BODY_SM_DF;

    

    const value = formatter
        ? formatters[formatter](getText(_value))
        : getText(_value)

    return (
        <TYPO_COMP {...(typoCompProps || {})} style={{ ...(color ? { color } : {}), ...(typoCompProps?.style || {}) }}>
            {`${value}${suffix || ''}`}
        </TYPO_COMP>
    )

    
}

export default TableText;